/*
  INSERT INTO _00rs (
    _dmn, _key, _fst, 
    _00r_31r1f, _00r_10r1f, 
    _icn, _00ra1100s, 
    _00ra2100s, _00ra2200i,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    1, 2, 2,
    1, 11,
    'staff1', '12341234',
    '9999-12-31 23:59:59', 0,
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );
 */

/*
・セキュリティの観点から、パスワードはユーザ情報と別にする
・ワンタイムパスワードは、履歴を保持すべきではない
・ログインID・パスワードの変更履歴は、可能な方が良い
→
・ワンタイムパスワードは、ユーザ情報・ログイン情報と別管理とし、履歴を保持しない
・ログインID・パスワードは、ユーザ情報と別管理とし、履歴を保持する
 */
export const _00z = { // 履歴対象外
  _00r: { // 確認コード情報
    v0: {
      itlz: {
        _00r_31r1f: -1, 
        _00r_10r1k: -1,
        _00rd1100s: '',
        _00ra1100s: '',
        _00ra2100i:  0,
      },
      fldz: {
        _00r_31r1f: { // 所属組織 
        },
//        _00r_10r1f: { // ユーザ 
        _00r_10r1k: { // ユーザ 
        },
        _00rd1100s: { // 確認コード発行日時
        },
        _00ra1100s: { // 確認コード
        },
        _00ra2100i: { // 確認コード誤り回数
        },
      },
    },
  },
};
